import { createSlice } from "@reduxjs/toolkit";
import {
  fetchTherapists,
  fetchTherapistById,
  createTherapist,
  updateTherapist,
} from "../../reducer/therapistManagement/therapistManagementReducer";

const initialState = {
  list: [],
  pagination: { page: 1, limit: 10, total: 0, totalPages: 1 },
  isLoading: false,
  error: null,

  // Single therapist detail
  detail: null,
  detailLoading: false,
  detailError: null,

  // Create / Update
  saving: false,
  saveError: null,
};

const therapistManagementSlice = createSlice({
  name: "therapistManagement",
  initialState,
  reducers: {
    clearDetail: (state) => {
      state.detail = null;
      state.detailError = null;
    },
  },
  extraReducers: (builder) => {
    // Fetch list
    builder
      .addCase(fetchTherapists.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchTherapists.fulfilled, (state, action) => {
        state.isLoading = false;
        state.list = action.payload?.therapists || [];
        state.pagination = action.payload?.pagination || state.pagination;
      })
      .addCase(fetchTherapists.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || action.error.message;
      });

    // Fetch by ID
    builder
      .addCase(fetchTherapistById.pending, (state) => {
        state.detailLoading = true;
        state.detailError = null;
      })
      .addCase(fetchTherapistById.fulfilled, (state, action) => {
        state.detailLoading = false;
        state.detail = action.payload;
      })
      .addCase(fetchTherapistById.rejected, (state, action) => {
        state.detailLoading = false;
        state.detailError = action.payload || action.error.message;
      });

    // Create
    builder
      .addCase(createTherapist.pending, (state) => {
        state.saving = true;
        state.saveError = null;
      })
      .addCase(createTherapist.fulfilled, (state) => {
        state.saving = false;
      })
      .addCase(createTherapist.rejected, (state, action) => {
        state.saving = false;
        state.saveError = action.payload || action.error.message;
      });

    // Update
    builder
      .addCase(updateTherapist.pending, (state) => {
        state.saving = true;
        state.saveError = null;
      })
      .addCase(updateTherapist.fulfilled, (state, action) => {
        state.saving = false;
        state.detail = action.payload;
      })
      .addCase(updateTherapist.rejected, (state, action) => {
        state.saving = false;
        state.saveError = action.payload || action.error.message;
      });
  },
});

export const { clearDetail } = therapistManagementSlice.actions;
export default therapistManagementSlice.reducer;
